/**
 * HeroBanner class component
 */
import Splide from '@splidejs/splide'

class HeroBanner {
    constructor(domElement = null) {
        this.container = $(domElement)
        if(!this.container.length) {
            console.error('Please provide proper DOM element for HeroBanner class')
            return
        }

        this.contentWrapper = this.container.find('.hero-banner--inner-wrapper')
        this.bannerWrapper = this.container.find('.hero-banner--content--wrapper')

        this.bookingPanel = this.container.find('.quick-booking-panel--container')
        this.bookingWrapper = this.container.find('.quick-booking-panel--wrapper')

        this.Autoplay = null

        // Slider init
        this.initSlider()

        // Set height of wrapper
        this.setLayoutHeight()

        // Attach event listeners
        this.setEventListeners()
    }

    /**
     * Destructor method
     */
    destroy() {
        this.removeEventListeners()
    }

    /**
     * Attach event listeners
     */
    setEventListeners() {
        if(this.bookingPanel.length) {
            this.container.on('click touch', '.quick-booking-panel--toggle', this.toggleBookingPanel.bind(this))

            this.container.on('click touch', '.add-new-flight-btn', this.setSliderHeight.bind(this))
            this.container.on('click touch', '.remove-flight-btn', this.setSliderHeight.bind(this))

            // Pause autoplay if user is making any action on panel
            this.container.on('focus', '.quick-booking-panel input', () => {
                if (this.Autoplay) {
                    this.Autoplay.pause()
                }
            })

            // Enable autoplay afterwards
            this.container.on('blur', '.quick-booking-panel input', () => {
                if (this.Autoplay) {
                    this.Autoplay.play()
                }
            })
        }

        $(window).on('resize.hero-banner', () => this.setLayoutHeight())

        // Stop/Resume autoplay on action button hover
        this.container.on('mouseenter mouseleave', '.buttons-container .btn', () => {
            if (this.Autoplay) {
                this.Autoplay.isPaused() ? this.Autoplay.play() : this.Autoplay.pause()
            }
        })
    }

    /**
     * Remove event listeners
     */
    removeEventListeners() {
        this.container.off('click touch')
        this.container.off('focus blur')
        this.container.off('mouseenter mouseleave')

        $(window).off('resize.hero-banner')
    }

    /**
     * Slider initialization
     */
    initSlider() {
        this.sliderContainer = this.container.find('.splide')
        this.Splide = new Splide(this.sliderContainer[0], {
            speed: 750,
            interval: 5500,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoHeight: true,
            rewind: true,
            easing: 'cubic-bezier(0, 0, 0.5, 1)'
        })

        this.Splide.mount()

        const {
            Arrows: {
                arrows
            },
            Autoplay,
        } = this.Splide.Components

        this.Autoplay = Autoplay

        // Loop autoplay but hide arrows
        $(arrows.prev).addClass('disabled')
        this.Splide.on('moved', (newIndex) => {
            $(arrows.next).removeClass('disabled')
            $(arrows.prev).removeClass('disabled')

            if (newIndex === 0) {
                $(arrows.prev).addClass('disabled')
            }
            if (newIndex + 1 === this.Splide.length) {
                $(arrows.next).addClass('disabled')
            }
        })
    }

    /**
     * Set height of layout (Mobile only)
     */
    setLayoutHeight() {
        if (window.innerWidth < 600) {
            const headerHeight = $('header.header').height()
            const calculatedHeight = window.innerHeight - headerHeight

            this.container.find('.splide__slide').css('minHeight', `${calculatedHeight}px`)

            if (this.bookingWrapper.length) {
                this.bookingPanel.css('minHeight', `${window.innerHeight}px`)
                this.bookingWrapper.css('minHeight', `${window.innerHeight}px`)
            }
        } else {
            this.container.find('.splide__slide').css('minHeight', '')

            if (this.bookingWrapper.length) {
                this.bookingPanel.css('minHeight', '')
                this.bookingWrapper.css('minHeight', '')
            }
        }
    }

    /**
     * Booking panel height can affect slider height
     */
    setSliderHeight() {
        // For mobile, slide is full window width
        if (window.innerWidth < 600) {
            return
        }

        const panelHeight = this.bookingPanel.parent().height()
        const slideHeight = this.container.find('.splide__slide').height()

        if (panelHeight > slideHeight) {
            this.container.find('.splide__slide').css('minHeight', panelHeight + 50)
        } else {
            this.container.find('.splide__slide').css('minHeight', '')
        }
    }

    /**
     * Show/Hide quick booking panel
     */
    toggleBookingPanel() {
        if (this.bookingPanel.hasClass('active')) {
            this.bookingPanel.removeClass('active')
            this.contentWrapper.removeClass('booking-visible')

            $('body').removeClass('disable-scroll')
        } else {
            this.bookingPanel.addClass('active')
            this.contentWrapper.addClass('booking-visible')

            $('body').addClass('disable-scroll')
        }
    }
}

export default HeroBanner
